// Importing necessary components for routing and functionality
import { BrowserRouter, Routes, Route } from "react-router-dom"; // Imports for routing
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import ContactUsPage from "./components/ContactUsPage";
import ActivityLoggingPage from "./components/ActivityLoggingPage";
import ProgressDashboardPage from "./components/ProgressDashboard";
import SignUpPage from "./components/SignUpPage";
import AnalyticsPage from "./components/AnalyticsPage";
import AboutUs from "./components/AboutUs";
import Services from "./components/Services";
import ForgotPasswordPage from "./components/ForgotPassword";
import RegistrationPage from "./components/NewRegister";
import Chat from "./components/Chat";
import Dashboard from "./components/Dashboard"; // Importing the Dashboard component
import BMICalculatorPage from "./components/bmiCalculator"; // Importing the BMI Calculator component
import ProfilePage from "./components/ProfilePage";
import ForgotPassword from "./components/ForgotPassword";
import LogsDashboard from "./components/LogsDashboard";
import SetWorkoutGoals from "./components/SetWorkoutGoals";
function App() {
  return (
    // Setting up the routing structure for the application
    <BrowserRouter>
      <Routes>
        {/* Defining the route for the home page */}
        <Route path="/" element={<HomePage />} />  {/* User Registration/Login component */}
        
        {/* Other application routes */}
        <Route path="/login" element={<LoginPage />} /> {/* login Us page */}
        <Route path="/contactus" element={<ContactUsPage />} /> {/* login Us page */}
        <Route path="/activitylogging" element={<ActivityLoggingPage />} /> {/* Activity Logging page */}
        <Route path="/progressdashboard" element={<ProgressDashboardPage />} /> {/* Activity Logging page */}
         {/* User Registration/Login component */}
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
        <Route path="/setgoals" element={<SetWorkoutGoals/>}/>
        
        <Route path="/register" element={<RegistrationPage />} /> {/* New Registration page */}
        <Route path="/chat" element={<Chat />} /> {/* Chat component */}
        <Route path="/dashboard" element={<Dashboard/>}/>
        <Route path="/bmicalculator" element={<BMICalculatorPage />} /> {/* BMI Calculator page */}
        <Route path="/profile" element={<ProfilePage />} /> {/* Profile page */}
        <Route path="/forgotpassword" element={<ForgotPassword />} /> {/* Forgot Password page */}
        <Route path="/logs" element={<LogsDashboard />} /> {/* Logs Dashboard page */}
        {/* Add more routes as needed */}
        </Routes>
    </BrowserRouter>
  );
}

export default App; // Exporting the App component for use in other parts of the application
